import { $elementChild } from "@grindex-common/helpers/elements";

export class ProductsCompareItem {
	constructor($container) {
		this.$container = $container;
		this.$label = $elementChild($container, "compare-label");
		this.$checkBox = $elementChild($container, "compare-checkbox");
		this.id = $container.dataset.id;
	}

	isSelected() {
		return this.$checkBox.checked;
	}

	select() {
		this.$checkBox.checked = true;
		this.$label.classList.add("button");
	}

	unSelect() {
		this.$checkBox.checked = false;
		this.$label.classList.remove("button");
	}

	enable() {
		this.$checkBox.disabled = false;
		this.$label.classList.remove("disabled");
	}

	disable() {
		this.$checkBox.disabled = true;
		this.$label.classList.add("disabled");
	}

	hide() {
		this.$container.classList.add("hidden");
	}

	show() {
		this.$container.classList.remove("hidden");
	}
}
